export const SIDEBAR_NAVIGATE_EVENT = "app:sidebar-navigate";

let navigationGuard = null;

export function registerNavigationGuard(guardFn) {
  navigationGuard = guardFn;
}

export function unregisterNavigationGuard() {
  navigationGuard = null;
}

/**
 * Returns false when a builder blocked the navigation (dialog shown).
 */
export function canNavigateTo(targetPath) {
  if (!navigationGuard) return true;

  const currentPath = window.location.pathname;
  const normalizedTarget = targetPath?.split("?")[0] || "";
  if (
    normalizedTarget &&
    (currentPath === normalizedTarget ||
      currentPath === `${normalizedTarget}/` ||
      `${currentPath}/` === normalizedTarget)
  ) {
    return true;
  }

  return navigationGuard(targetPath);
}

export function dispatchSidebarNavigate() {
  window.dispatchEvent(new CustomEvent(SIDEBAR_NAVIGATE_EVENT));
}

export function subscribeSidebarNavigate(handler) {
  window.addEventListener(SIDEBAR_NAVIGATE_EVENT, handler);
  return () => window.removeEventListener(SIDEBAR_NAVIGATE_EVENT, handler);
}
